module.exports = __webpack_public_path__ + "img/capability-app-desktop.2821ecf3.png";